/* eslint-disable max-depth */

import { isArray } from "lodash";

/* eslint-disable max-statements */
export const labelText = (label, required) => `${label}${required ? " *" : ""}`;

export const shouldHide = (logic, values = {}, fields = {}) => {
	if (!logic || !logic.length) {
		return false;
	}

	for (const idx in logic) {
		if (logic[idx]) {
			for (const idy in logic[idx]) {
				if (logic[idx][idy]) {
					const { field, operator, value } = logic[idx][idy];
					const currentValue = values[fields[field].name];

					// eslint-disable-next-line no-eval
					if (eval(`"${currentValue}" ${operator} "${value}"`)) {
						return false;
					}
				}
			}
		}
	}

	return true;
};

export const assocFields = (fields) => fields.reduce(
	(prev, cur) => {
		prev[cur.key] = cur;
		return prev;
	},
	{}
);

export const transformCheckboxValues = (values) => Object.entries(values).
	reduce((prev, [key, value]) => {
		if (isArray(value) && value.length === 1 && value[0] === "on") {
			prev[key] = true;
		} else {
			prev[key] = value;
		}
		return prev;
	}, {});
